function SortArrow(props: any) {
  const className = props.className || '';
  const fillMatch = className.match(/fill-[\w-]+/);
  const fillClass = fillMatch ? fillMatch[0] : '';
  const otherClasses = className.replace(/fill-[\w-]+/g, '').trim();
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 16 16"
      className={otherClasses}
    >
      <path
        d="M8.00083 10.2259L4.28125 6.52295H11.7204L8.00083 10.2259Z"
        className={fillClass}
      />
    </svg>
  );
}

export default SortArrow;
